// extracted by mini-css-extract-plugin
export default {"titleStyle":"carbonEmissionComponent_titleStyle__j8IY9","subTitleStyle":"carbonEmissionComponent_subTitleStyle__fm2u9","noteStyle":"carbonEmissionComponent_noteStyle__6q-EU"};